import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"search\"><style>#search .st1{fill:none;stroke:#3c4859;stroke-width:24;stroke-linecap:round;stroke-miterlimit:10}</style><path fill=\"none\" d=\"M0 .4h400v400H0z\" /><circle class=\"st1\" cx=\"183.9\" cy=\"183.9\" r=\"86.5\" /><path class=\"st1\" d=\"M302.6 302.6l-57.5-57.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol